export default {
  label: {
    button: {
      clearButton: 'Limpar tudo',
    },
  },
};
